export default __webpack_public_path__ + "static/media/saint-omer3.7b4f18db.jpg";